import { makeAutoObservable } from 'mobx';
import IGeoCoordinate from '../interfaces/IGeoCoordinate';

export default class StreetViewStore {
    coordinates: IGeoCoordinate | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setCoordinates(coordinates: IGeoCoordinate) {
        this.coordinates = coordinates;
    }

    clear() {
        this.coordinates = null;
    }
}